// services/dashboardService.js
import { apiService } from './api';

export const dashboardService = {
  getDashboardStats: async () => {
    try {
      const response = await apiService.get('/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Dashboard API error:', error);
      throw error;
    }
  },
  
  getStatsSummary: async () => {
    try {
      const response = await apiService.get('/dashboard/stats/summary');
      return response.data;
    } catch (error) {
      console.error('Stats summary error:', error);
      throw error;
    }
  },
  
  getMonthlyData: async (months = 6) => {
    try {
      const response = await apiService.get(`/dashboard/monthly-data?months=${months}`);
      return response.data;
    } catch (error) {
      console.error('Monthly data error:', error);
      throw error;
    }
  }
};






















// // services/dashboardService.js
// import { apiService } from './api';

// export const dashboardService = {
//   getDashboardStats: async () => {
//     try {
//       const response = await apiService.get('/dashboard/stats');
//       return response.data;
//     } catch (error) {
//       // Mock data for development
//       return {
//         stats: {
//           totalPosts: 245,
//           totalUsers: 1234,
//           totalViews: 45678,
//           totalComments: 892,
//           totalCategories: 12,
//           engagementRate: 68,
//           postsTrend: 12,
//           usersTrend: 8,
//           viewsTrend: 24,
//           commentsTrend: -3,
//           categoriesTrend: 5,
//           engagementTrend: 4
//         },
//         recentPosts: [
//           { id: 1, title: 'Getting Started with React', categoryName: 'Tutorials', viewCount: 1234, createdAt: new Date().toISOString() },
//           { id: 2, title: 'Advanced CSS Techniques', categoryName: 'CSS', viewCount: 892, createdAt: new Date(Date.now() - 86400000).toISOString() },
//           { id: 3, title: 'JavaScript Best Practices', categoryName: 'JavaScript', viewCount: 756, createdAt: new Date(Date.now() - 172800000).toISOString() }
//         ],
//         recentComments: [
//           { id: 1, userName: 'John Doe', content: 'Great article! Very helpful.', postTitle: 'Getting Started with React', createdAt: new Date().toISOString() },
//           { id: 2, userName: 'Jane Smith', content: 'Thanks for sharing this.', postTitle: 'Advanced CSS Techniques', createdAt: new Date(Date.now() - 86400000).toISOString() }
//         ],
//         topPosts: [
//           { id: 1, title: 'Getting Started with React', viewCount: 1234, likes: 89, commentCount: 45, trend: 15 },
//           { id: 2, title: 'Advanced CSS Techniques', viewCount: 892, likes: 67, commentCount: 34, trend: 12 },
//           { id: 3, title: 'JavaScript Best Practices', viewCount: 756, likes: 56, commentCount: 28, trend: 8 }
//         ],
//         popularCategories: [
//           { id: 1, name: 'Tutorials', count: 45, color: '#4f46e5' },
//           { id: 2, name: 'JavaScript', count: 32, color: '#f59e0b' },
//           { id: 3, name: 'CSS', count: 28, color: '#10b981' },
//           { id: 4, name: 'React', count: 24, color: '#3b82f6' }
//         ],
//         monthlyData: [
//           { month: 'Jan', views: 4200 },
//           { month: 'Feb', views: 4800 },
//           { month: 'Mar', views: 5200 },
//           { month: 'Apr', views: 6100 },
//           { month: 'May', views: 6800 },
//           { month: 'Jun', views: 7500 }
//         ],
//         recentUsers: [
//           { id: 1, userName: 'john_doe', email: 'john@example.com', createdAt: new Date().toISOString(), avatarColor: '#4f46e5' },
//           { id: 2, userName: 'jane_smith', email: 'jane@example.com', createdAt: new Date(Date.now() - 86400000).toISOString(), avatarColor: '#10b981' }
//         ]
//       };
//     }
//   }
// };